/* eslint-disable no-unused-vars */
import React, {
  Component,
  useContext,
  useRef,
  useCallback,
  useEffect,
} from 'react';
// import PropTypes from 'prop-types';
/* eslint-enable no-unused-vars */
import { fadeInUpComponent } from '../style';
import survey from '../../../context/survey';
import sendRAT, { ACTION, SCREEN } from '../../../app/rat';
import Thanks from '../../thanks/Thanks';
import { Broadcast } from '../../../../../embedded-type/broadcast';

const FadeinThanksComponent = fadeInUpComponent(Thanks);

/**
 * widget - Thanks
 * - 表示に RAT `appear` 送信します
 * - 表示後 3000ms 後に消えます
 * - step: 99 - message 表示
 * - step: 999 - message 表示ナシ
 * @param {*} state React.Context survey.state
 * @param {function} dispatch React.Context survey.dispatch
 * @param {*} [submit={}] Redux.store.submit submit 状態を保持します
 * @return {*} React.node - Thanks
 * @constructor
 */
const WidgetThanks = ({ state, dispatch, submit = {} }) => {
  // /**
  //  * state {object} - {@link config}.reduce 戻り値
  //  * dispatch {function} - {@link config}.Context state 変更関数 - type 指定を行います
  //  */
  // const { state, dispatch } = useContext(survey.Context);

  const { config, step } = state;

  // thanks 表示後に 3000ms 経過後に消去する timer id
  const timerId = useRef(0);

  const cleanupWithUnmount = useCallback(() => {
    clearTimeout(timerId.current);
  }, [timerId]);

  // close button click handler
  const closeAll = useCallback(() => {
    state.type = survey.events.UPDATE;
    state.step = -1;
    dispatch(state);
  }, [dispatch, state]);

  // unmount
  useEffect(() => {
    // unmount
    return cleanupWithUnmount;
  }, [cleanupWithUnmount]);

  // did update
  useEffect(() => {
    if (step === 99 || step === 999) {
      if (!submit.meta || !submit.meta.thanks) {
        if (submit.meta) {
          Broadcast.submit.thanks();
        }
        // RAT - thankyou appear
        // console.log('WidgetThanks - ACTION.APPEAR', ACTION.APPEAR, submit.meta)
        sendRAT({
          cId: config.cId.value,
          screen: SCREEN.THANKYOU,
          action: ACTION.APPEAR,
        });
      }
      // 3000ms delay close all
      timerId.current = setTimeout(closeAll, 3000);
    }
  }, [step, config.cId.value, closeAll, submit]);

  const onClick = useCallback(
    event => {
      // close click event handler
      event.preventDefault();
      // clear time out
      cleanupWithUnmount();
      // close all
      closeAll();
    },
    [cleanupWithUnmount, closeAll]
  );

  // 99 - normal end
  // 999 - Permission No
  return (
    step >= 99 && (
      <FadeinThanksComponent
        title={config.thanks.txt0}
        message={step === 99 ? config.thanks.txt1 : ''}
        onClick={onClick}
        state={state}
        dispatch={dispatch}
      />
    )
  );
};

export default WidgetThanks;



// WEBPACK FOOTER //
// ./src/phase2/survey/page/widget/sequences/WidgetThanks.js